export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/arts_crafts.3379cd6.svg";